/**
 * Locale-aware formatters. The shell speaks Hebrew (he-IL); helpers
 * here keep number/date formatting consistent across the app.
 */

const numberFmt = new Intl.NumberFormat('he-IL');
const relFmt = new Intl.RelativeTimeFormat('he-IL', { numeric: 'auto' });

export function formatNumber(value: number): string {
  return numberFmt.format(value);
}

export function formatPercent(value: number, fractionDigits = 1): string {
  return new Intl.NumberFormat('he-IL', {
    style: 'percent',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value);
}

const RELATIVE_UNITS: { unit: Intl.RelativeTimeFormatUnit; ms: number }[] = [
  { unit: 'year',   ms: 365 * 24 * 60 * 60 * 1000 },
  { unit: 'month',  ms: 30 * 24 * 60 * 60 * 1000 },
  { unit: 'week',   ms: 7 * 24 * 60 * 60 * 1000 },
  { unit: 'day',    ms: 24 * 60 * 60 * 1000 },
  { unit: 'hour',   ms: 60 * 60 * 1000 },
  { unit: 'minute', ms: 60 * 1000 },
  { unit: 'second', ms: 1000 },
];

export function formatRelative(timestampMs: number, nowMs: number = Date.now()): string {
  const diff = timestampMs - nowMs;
  const abs = Math.abs(diff);
  for (const { unit, ms } of RELATIVE_UNITS) {
    if (abs >= ms || unit === 'second') {
      return relFmt.format(Math.round(diff / ms), unit);
    }
  }
  return relFmt.format(0, 'second');
}
